import { NotificationDto } from '@/api/Clients/Types/NotificationDto'
import { NPaymentProviderDto } from '@/api/NPayments/Types/NPaymentProviderDto'
import { BonusCampaignsDto } from '@/api/Wallet/Types/MarketingBonusCampaignDto'
import { PaymentProviderTab } from '@/routes/Administration/PaymentProviders/PaymentProviderSlug'
import { BonusCampaignTab } from '@/routes/Marketing/BonusModule/BonusCampaignSlug'
import { NotificationTab } from '@/routes/Marketing/Notifications/NotificationSlug'
import { AffiliateDto } from 'api/Affiliate/AffiliateDto'
import { TestStatusTabs } from 'api/Clients/Types/AppropriatenessTestDto'
import { ClientDetailedDto } from 'api/Clients/Types/ClientDetailedDto'
import { DemoAccountDetails } from 'api/Clients/Types/DemoAccountDetails'
import { TradingAccountDetailDto } from 'api/Clients/Types/TradingAccountDetails'
import { WelcomeAccountDetails } from 'api/Clients/Types/WelcomeAccountDetails'
import { LeadDetailsDto } from 'api/Leads/Types/LeadDetailsDto'
import { AccountGroupDto } from 'api/Trading-Accounts/Types/AccountGroupDto'
import { IntroducingBrokerDetailedProfileDto } from 'api/Trading-Accounts/Types/IntroducingBrokerDetailedProfileDto'
import { IntroducingBrokerDetailsDto } from 'api/Trading-Accounts/Types/IntroducingBrokerDetailsDto'
import { MarketingCampaignDetailDto } from 'api/Trading-Accounts/Types/MarketingCampaignDetailDto'
import { SubscriptionDetailsDto } from 'api/Trading-Accounts/Types/SubscriptionDetailsDto'
import { SubscriptionPlatformDetailsDto } from 'api/Trading-Accounts/Types/SubscriptionPlatformDetailsDto'
import { WalletDto } from 'api/Wallet/Types/Wallet'
import { SubscriptionTab } from 'routes/Administration/Subscriptions/SubscriptionSlug'
import { IntroducingBrokerProfileTypes } from 'routes/Brokerage/IntroducingBrokerProfiles/Details/IntroducingBrokerProfile/types'
import { CampaignTab } from 'routes/Marketing/CampaignSlug'
import { AffiliateTabs } from 'routes/Records/Affiliates/RecordsAffiliates/Details/AffiliateSlug'
import { ClientTab } from 'routes/Records/Clients/Navigation/ClientNavigation'
import { IntroducingBrokerTab } from 'routes/Records/IB/IntroducingBrokerSlug'
import { LeadTab } from 'routes/Records/Leads/Details/LeadSlug'
import { TradingAccountTab } from 'routes/Records/TradingAccounts/Navigation/TradingAccountNavigation'
import { WalletTab } from 'routes/Records/Wallets/WalletSlug'
import { TicketsViewType } from 'routes/Tickets/TicketsViewType'

import { appENV, checkWindowLocation } from './dom'
import { TenantFeature } from './Tenant'

export type LinkType = Record<
  TenantFeature,
  {
    feature?: TenantFeature
    url: string
    addUrl?: string
    detailsUrl?: string
    enabled: appENV[]
  }
>

export const links: LinkType = {
  login: {
    feature: TenantFeature.login,
    url: '/login',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  forgotPassword: {
    feature: TenantFeature.forgotPassword,
    url: '/forgot-password',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  search: {
    feature: TenantFeature.search,
    url: '/search',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  dashboard: {
    feature: TenantFeature.dashboard,
    url: '/dashboard',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  recordsAffiliates: {
    feature: TenantFeature.recordsAffiliates,
    url: '/records/affiliates',
    detailsUrl: '/records/affiliates/:id/:slug',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  recordsClients: {
    feature: TenantFeature.recordClients,
    url: '/records/clients',
    detailsUrl: '/records/clients/:id/:slug',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  recordsWallets: {
    feature: TenantFeature.recordsWallets,
    url: '/records/wallets',
    detailsUrl: '/records/wallets/:id/:slug',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  clientTestFilledWindow: {
    feature: TenantFeature.clientTestFilledWindow,
    url: '/records/client-test/filled',
    detailsUrl: '/records/client-test/filled/:type/:clientId/:testId',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  clientEditTestFormWindow: {
    feature: TenantFeature.clientEditTestFormWindow,
    url: '/records/client-test/form',
    detailsUrl: '/records/client-test/form/:type/:clientId/:testId',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  clientNewTestFormWindow: {
    feature: TenantFeature.clientNewTestFormWindow,
    url: '/records/client-test/form',
    detailsUrl: '/records/client-test/form/:type/:clientId',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  recordsTradingAccounts: {
    feature: TenantFeature.recordsTradingAccounts,
    url: '/records/trading-accounts',
    detailsUrl: '/records/trading-accounts/:id/:slug',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  recordsDemoAccounts: {
    feature: TenantFeature.recordsDemoAccounts,
    url: '/records/demo-accounts',
    detailsUrl: '/records/demo-accounts/:id/:slug',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  recordsWelcomeAccounts: {
    feature: TenantFeature.recordsWelcomeAccounts,
    url: '/records/welcome-accounts',
    detailsUrl: '/records/welcome-accounts/:id/:slug',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  recordsAccountGroups: {
    feature: TenantFeature.recordsAccountGroups,
    url: '/records/account-groups',
    detailsUrl: '/records/account-groups/:id/:slug',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  recordsIntroducingBrokers: {
    feature: TenantFeature.recordsIntroducingBrokers,
    url: '/records/introducing-brokers',
    detailsUrl: '/records/introducing-brokers/:id/:slug',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  recordsPaymentAgents: {
    feature: TenantFeature.recordsPaymentAgents,
    url: '/records/payment-agents',
    detailsUrl: '/records/payment-agents/:id/*',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  recordsLeads: {
    feature: TenantFeature.recordLeads,
    url: '/records/leads',
    detailsUrl: '/records/leads/:id/:slug',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  createLead: {
    feature: TenantFeature.recordLeads,
    url: '/records/leads/create',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  recordsExchangeRates: {
    feature: TenantFeature.recordsExchangeRates,
    url: '/records/exchange-rates',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  recordsCurrencyMarkups: {
    feature: TenantFeature.recordsCurrencyMarkups,
    url: '/records/currency-markups',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },

  tickets: {
    feature: TenantFeature.tickets,
    url: '/tickets',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  ticketsPayments: {
    feature: TenantFeature.ticketsPayments,
    url: '/tickets/payments',
    detailsUrl: '/tickets/payments/:id/*',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  ticketsBackoffice: {
    feature: TenantFeature.ticketsBackOffice,
    url: '/tickets/backoffice',
    detailsUrl: '/tickets/backoffice/:id/*',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  ticketsCompliance: {
    feature: TenantFeature.ticketsCompliance,
    url: '/tickets/compliance',
    detailsUrl: '/tickets/compliance/:id/*',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  ticketsTranslation: {
    feature: TenantFeature.ticketsTranslation,
    url: '/tickets/translations',
    detailsUrl: '/tickets/translations/:id/*',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  ticketsBrokerage: {
    feature: TenantFeature.ticketsBrokerage,
    url: '/tickets/brokerage',
    detailsUrl: '/tickets/brokerage/:id/*',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  ticketsSales: {
    feature: TenantFeature.ticketsSales,
    url: '/tickets/sales',
    detailsUrl: '/tickets/sales/:id/*',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  ticketsMyTickets: {
    feature: TenantFeature.ticketsMyTickets,
    url: '/tickets/my-tickets',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },

  transactionWalletAdjustments: {
    feature: TenantFeature.transactionWalletAdjustments,
    url: '/transactions/wallet-adjustments',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  transactionWallet: {
    feature: TenantFeature.transactionWallet,
    url: '/transactions/wallet',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  transactionPlatform: {
    feature: TenantFeature.transactionPlatform,
    url: '/transactions/platform',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  transactionDepositWithdrawal: {
    feature: TenantFeature.transactionDepositWithdrawal,
    url: '/transactions/wallet-deposit-withdrawal',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  transactionIBCommissions: {
    feature: TenantFeature.transactionIBCommissions,
    url: '/transactions/ib-commissions',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  transactionIBCashBacks: {
    feature: TenantFeature.transactionIBCashBacks,
    url: '/transactions/ib-cashbacks',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  transactionIBCashbackSettings: {
    feature: TenantFeature.transactionIBCashbackSettings,
    url: '/transactions/ib-cashback-settings',
    detailsUrl: '/transactions/ib-cashback-settings/:id/*',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  transactionUnsubscribeRequests: {
    feature: TenantFeature.transactionUnsubscribeRequests,
    url: '/transactions/unsubscribe-requests',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  transactionTradingAccountAdjustments: {
    feature: TenantFeature.transactionTradingAccountAdjustments,
    url: '/transactions/trading-account-adjustments',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  transactionBonus: {
    feature: TenantFeature.transactionBonus,
    url: '/transactions/bonus',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  transactionPaymentAgent: {
    feature: TenantFeature.transactionPaymentAgent,
    url: '/transactions/payment-agent',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  transactionBulkWithdrawals: {
    feature: TenantFeature.transactionBulkWithdrawals,
    url: '/transactions/bulk-withdrawals',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  transactionBulkTransaction: {
    feature: TenantFeature.transactionBulkTransaction,
    url: '/transactions/file-upload-history',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  createTransaction: {
    feature: TenantFeature.createTransaction,
    url: '/transactions/create',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  createETDTransaction: {
    feature: TenantFeature.createETDTransaction,
    url: '/transactions/create/etd',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  administrationUsers: {
    feature: TenantFeature.administrationUsers,
    url: '/administration/users',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  administrationUserTeams: {
    feature: TenantFeature.administrationUserTeams,
    url: '/administration/user-teams',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  administrationRoles: {
    feature: TenantFeature.administrationRoles,
    url: '/administration/roles',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  administrationTeams: {
    feature: TenantFeature.administrationTeams,
    url: '/administration/teams',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  administrationCountries: {
    feature: TenantFeature.administrationCountries,
    url: '/administration/countries/main',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  administrationWallets: {
    feature: TenantFeature.administrationWallets,
    url: '/administration/countries/wallets',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  administrationTradingAccounts: {
    feature: TenantFeature.administrationTradingAccounts,
    url: '/administration/countries/trading-accounts',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  administrationProducts: {
    feature: TenantFeature.administrationProducts,
    url: '/administration/countries/products',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  administrationAllowedPaymentProvidersMatrix: {
    feature: TenantFeature.administrationAllowedPaymentProvidersMatrix,
    url: '/administration/payment-tools/payment-controls/allowed-psps/matrix',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  administrationAllowedPaymentProvidersUncovered: {
    feature: TenantFeature.administrationAllowedPaymentProvidersUncovered,
    url: '/administration/payment-tools/payment-controls/allowed-psps/uncovered',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  administrationRateMarkups: {
    feature: TenantFeature.administrationRateMarkups,
    url: '/administration/rate-markups',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  administrationSubscriptions: {
    feature: TenantFeature.administrationSubscriptions,
    url: '/administration/subscriptions',
    detailsUrl: '/administration/subscriptions/:id/:slug',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  administrationPaymentProvidersConfig: {
    feature: TenantFeature.administrationPaymentProvidersConfig,
    url: '/administration/payment-providers/config',
    detailsUrl: '/administration/payment-providers/config/:id/:slug',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  administrationPaymentProvidersOrdering: {
    feature: TenantFeature.administrationPaymentProvidersConfig,
    url: '/administration/payment-providers/ordering',
    detailsUrl: '/administration/payment-providers/ordering/:id/:slug',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  administrationPaymentControls: {
    feature: TenantFeature.administrationPaymentControls,
    url: '/administration/payment-controls',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  administrationPaymentControlsPSPCheckState: {
    feature: TenantFeature.administrationPaymentControlsPSPCheckState,
    url: '/administration/payment-controls/psp-check-state',
    detailsUrl: '/administration/payment-controls/psp-check-state/:id/*',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  administrationMlWithdrawalAutomationGlobalControls: {
    feature: TenantFeature.administrationMlWithdrawalAutomationGlobalControls,
    url: '/administration/ml-withdrawal-automation/global-controls',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  administrationMlWithdrawalAutomationOverrides: {
    feature: TenantFeature.administrationMlWithdrawalAutomationOverrides,
    url: '/administration/ml-withdrawal-automation/overrides',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  administrationWithdrawalThresholds: {
    feature: TenantFeature.administrationWithdrawalThresholds,
    url: '/administration/withdrawal-thresholds',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  administrationTransactionProcessingMetrics: {
    feature: TenantFeature.administrationTransactionProcessingMetrics,
    url: '/administration/payment-tools/transaction-processing-metrics',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  administrationInterestRateConfigControls: {
    feature: TenantFeature.administrationInterestRateConfigControls,
    url: '/administration/interest-rate/controls',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  administrationInterestRateThresholds: {
    feature: TenantFeature.administrationInterestRateThresholds,
    url: '/administration/interest-rate/thresholds',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  administrationInterestRateEligibility: {
    feature: TenantFeature.administrationInterestRateEligibility,
    url: '/administration/interest-rate/eligibility',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  complianceCountryRisk: {
    feature: TenantFeature.complianceCountryRisk,
    url: '/compliance/country-risk',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  complianceWorldCheckCases: {
    feature: TenantFeature.complianceWorldCheckCases,
    url: '/compliance/world-check-cases',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  complianceAppropriatenessTests: {
    feature: TenantFeature.complianceAppropriatenessTests,
    url: '/compliance/appropriateness-tests',
    detailsUrl: '/compliance/appropriateness-tests/:id/*',
    enabled: [appENV.development, appENV.localhost, appENV.test],
  },
  disclaimerLossPercentage: {
    feature: TenantFeature.disclaimerLossPercentage,
    url: '/compliance/disclaimer-loss-percentage',
    detailsUrl: '/compliance/disclaimer-loss-percentage/:id/*',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  marketingCampaigns: {
    feature: TenantFeature.marketingCampaigns,
    url: '/marketing/campaigns',
    addUrl: '/marketing/campaigns/add',
    detailsUrl: '/marketing/campaigns/:id/:slug',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  marketingNotifications: {
    feature: TenantFeature.marketingNotifications,
    url: '/marketing/notifications',
    detailsUrl: '/marketing/notifications/:id/*',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  bonusModule: {
    feature: TenantFeature.bonusModule,
    url: '/marketing/bonus-module',
    detailsUrl: '/marketing/bonus-module/:id/:slug',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  rewardTypeManager: {
    feature: TenantFeature.rewardTypeManager,
    url: '/marketing/rewards-hub/rewards-type-manager',
    detailsUrl: '/marketing/rewards-hub/rewards-type-manager/:id/:slug',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  rewardPrograms: {
    feature: TenantFeature.rewardPrograms,
    url: '/marketing/rewards-hub/reward-programs',
    detailsUrl: '/marketing/rewards-hub/reward-programs/:id/:slug',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  sglLinkGenerator: {
    feature: TenantFeature.sglLinkGenerator,
    url: '/marketing/sgl-link-generator',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  ibLanding: {
    feature: TenantFeature.ibLanding,
    url: '/marketing/ib-landing',
    detailsUrl: '/marketing/ib-landing/:id/*',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  referralMaterials: {
    feature: TenantFeature.referralMaterials,
    url: '/marketing/referral-materials',
    detailsUrl: '/marketing/referral-materials/:id/*',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  referralMaterialsCategories: {
    feature: TenantFeature.referralMaterialsCategories,
    url: '/marketing/referral-materials/categories',
    detailsUrl: '/marketing/referral-materials/categories/:id/*',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  emails: {
    feature: TenantFeature.emails,
    url: '/marketing/emails',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  productVersions: {
    feature: TenantFeature.productVersions,
    url: '/product/versions',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  productFeatureFlags: {
    feature: TenantFeature.productFeatureFlags,
    url: '/product/feature-flags',
    detailsUrl: '/product/feature-flags/:id/*',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  productPlatformVersions: {
    feature: TenantFeature.productPlatformVersions,
    url: '/product/platform-versions',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  brokerageSwapFreeRating: {
    feature: TenantFeature.brokerageSwapFreeRating,
    url: '/brokerage/swap-free-rating',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  brokerageBulkRestrictions: {
    feature: TenantFeature.brokerageBulkRestrictions,
    url: '/brokerage/bulk-restrictions',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  brokerageDeals: {
    feature: TenantFeature.brokerageDeals,
    url: '/brokerage/deals',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  brokerageIBProfiles: {
    feature: TenantFeature.brokerageIBProfiles,
    url: '/brokerage/introducing-broker-profiles',
    detailsUrl: '/brokerage/introducing-broker-profiles/:id/:slug',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  brokerageInstruments: {
    feature: TenantFeature.brokerageInstruments,
    url: '/brokerage/instruments',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  brokerageLeverages: {
    feature: TenantFeature.brokerageLeverages,
    url: '/brokerage/leverages',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  brokerageDividends: {
    feature: TenantFeature.brokerageDividends,
    url: '/brokerage/:slug',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  brokeragePlatforms: {
    feature: TenantFeature.brokeragePlatforms,
    url: '/brokerage/platforms',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  brokeragePlatformsConfiguration: {
    feature: TenantFeature.brokeragePlatformsConfiguration,
    url: '/brokerage/platforms/platforms-configuration',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  brokeragePlatformsMT4Swaps: {
    feature: TenantFeature.brokeragePlatforms,
    url: '/brokerage/platforms/meta-trader-4/swaps',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  brokeragePlatformsMT5Swaps: {
    feature: TenantFeature.brokeragePlatforms,
    url: '/brokerage/platforms/meta-trader-5/swaps',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  brokeragePlatformsMT5Sessions: {
    feature: TenantFeature.brokeragePlatforms,
    url: '/brokerage/platforms/meta-trader-5/sessions',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  brokerageReferralsRestrictions: {
    feature: TenantFeature.brokerageReferralsRestrictions,
    url: '/brokerage/referrals-restrictions',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  profileSettings: {
    feature: TenantFeature.profileSettings,
    url: '/profile/edit',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  serverErrorServiceUnavailable: {
    feature: TenantFeature.serverErrorServiceUnavailable,
    url: '/503',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  ibLandingPage: {
    feature: TenantFeature.ibLandingPage,
    url: '/marketing/ib-landing-page',
    detailsUrl: '/marketing/ib-landing-page/:id/*',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  referralMaterialsPage: {
    feature: TenantFeature.referralMaterialsPage,
    url: '/marketing/ib-referral-material-page',
    detailsUrl: '/marketing/ib-referral-material-page/:id/*',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  administrationPlatformLinks: {
    feature: TenantFeature.administrationPlatformLinks,
    url: '/administration/platform-links',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
  administrationContactDetails: {
    feature: TenantFeature.administrationPlatformLinks,
    url: '/administration/contact-details',
    enabled: [appENV.production, appENV.development, appENV.localhost, appENV.test],
  },
}

export const appTestRouteUrl = (tab: TestStatusTabs | string) => {
  return `${links.complianceAppropriatenessTests.url}/${tab}`
}

export const clientDetailsRouteUrl = (clientDetails: ClientDetailedDto, tab: ClientTab) => {
  return `${links.recordsClients.url}/${clientDetails.id}/${tab}`
}

export const walletDetailsRouteUrl = (walletDto: WalletDto, tab: WalletTab) => {
  return `${links.recordsWallets.url}/${walletDto.id}/${tab}`
}

export const tradingAccountDetailsRouteUrl = (
  tradingAccount: TradingAccountDetailDto,
  tab: TradingAccountTab
) => {
  return `${links.recordsTradingAccounts.url}/${tradingAccount.id}/${tab}`
}

export const tradingAccountDemoDetailsRouteUrl = (
  tradingAccount: DemoAccountDetails,
  tab: TradingAccountTab
) => {
  return `${links.recordsDemoAccounts.url}/${tradingAccount.id}/${tab}`
}

export const tradingAccountWelcomeDetailsRouteUrl = (
  tradingAccount: DemoAccountDetails | WelcomeAccountDetails,
  tab: TradingAccountTab
) => {
  return `${links.recordsWelcomeAccounts.url}/${tradingAccount.id}/${tab}`
}

export const accountGroupDetailsRouteUrl = (accountGroupDto: AccountGroupDto) => {
  return `${links.recordsAccountGroups.url}/${accountGroupDto.id}/details`
}

export const introducingBrokerDetailsRouteUrl = (
  ib: IntroducingBrokerDetailsDto,
  tab: IntroducingBrokerTab
) => {
  return `${links.recordsIntroducingBrokers.url}/${ib.id}/${tab}`
}

export const introducingBrokerProfileDetailsRouteUrl = (
  ib: IntroducingBrokerDetailedProfileDto,
  tab: IntroducingBrokerProfileTypes
) => {
  return `${links.brokerageIBProfiles.url}/${ib.id}/${tab}`
}

export const leadDetailsRouteUrl = (lead: LeadDetailsDto, tab: LeadTab) => {
  return `${links.recordsLeads.url}/${lead.id}/${tab}`
}

export const marketingCampaignDetailsRouteUrl = (
  campaign: MarketingCampaignDetailDto,
  tab: CampaignTab
) => {
  return `${links.marketingCampaigns.url}/${campaign.id}/${tab}`
}

export const marketingCampaignAddRouteUrl = () => {
  return links.marketingCampaigns.addUrl ?? `${links.marketingCampaigns.url}/add`
}

export const marketingBonusCampaignDetailsRouteUrl = (
  campaign: BonusCampaignsDto,
  tab: BonusCampaignTab
) => {
  return `${links.bonusModule.url}/${campaign.id}/${tab}`
}

export const subscriptionDetailsRouteUrl = (
  campaign: SubscriptionDetailsDto,
  tab: SubscriptionTab
): string => {
  return `${links.administrationSubscriptions.url}/${campaign.id}/${tab}`
}

export const paymentProviderDetailsRouteUrl = (
  paymentProvider: NPaymentProviderDto,
  tab: PaymentProviderTab
): string => {
  return `/administration/payment-providers/config/${paymentProvider.id}/${tab}`
}

export const subscriptionPlatformsRouteUrl = (
  platform: SubscriptionPlatformDetailsDto,
  tab: SubscriptionTab
): string => {
  return `${links.administrationSubscriptions.url}/${platform.subscription.id}/${tab}`
}

export const appropriatenessTestDetailsUrl = (testId: string) => {
  return `${links.complianceAppropriatenessTests.url}/${testId}`
}

export const affiliateDetailsRouteUrl = (affiliate: AffiliateDto, tab: AffiliateTabs): string => {
  return `/records/affiliates/${affiliate.externalId}/${tab}`
}

export const ticketRouteUrl = (viewType: TicketsViewType) => {
  switch (viewType) {
    case TicketsViewType.Payments:
      return {
        title: 'Payment Tickets',
        link: links.ticketsPayments.url,
      }
    case TicketsViewType.BackOffice:
      return {
        title: 'Backoffice Tickets',
        link: links.ticketsBackoffice.url,
      }
    case TicketsViewType.Sales:
      return {
        title: 'Sales Tickets',
        link: links.ticketsSales.url,
      }
    case TicketsViewType.Compliance:
      return {
        title: 'Compliance Tickets',
        link: links.ticketsCompliance.url,
      }
    case TicketsViewType.Translation:
      return {
        title: 'Translation Tickets',
        link: links.ticketsTranslation.url,
      }
    case TicketsViewType.Brokerage:
      return {
        title: 'Brokerage',
        link: links.ticketsBrokerage.url,
      }
    case TicketsViewType.MyTickets:
      return {
        title: 'My Tickets',
        link: links.ticketsMyTickets.url,
      }
    default:
      throw new TypeError('Ticket view type not found')
  }
}

export const ticketDetailsRouteUrl = (ticketId: string, viewType: TicketsViewType) => {
  switch (viewType) {
    case TicketsViewType.Payments:
      return `${links.ticketsPayments.url}/${ticketId}/details`
    case TicketsViewType.BackOffice:
      return `${links.ticketsBackoffice.url}/${ticketId}/details`
    case TicketsViewType.Sales:
      return `${links.ticketsSales.url}/${ticketId}/details`
    case TicketsViewType.Compliance:
      return `${links.ticketsCompliance.url}/${ticketId}/details`
    case TicketsViewType.Translation:
      return `${links.ticketsTranslation.url}/${ticketId}/details`
    case TicketsViewType.MyTickets:
      return `${links.ticketsMyTickets.url}/${ticketId}/details`
    case TicketsViewType.Brokerage:
      return `${links.ticketsBrokerage.url}/${ticketId}/details`
    default:
      throw new TypeError('Ticket view type not found')
  }
}

export const notificationDetailsRouteUrl = (
  notification: NotificationDto,
  tab: NotificationTab
) => {
  return `${links.recordsWallets.url}/${notification.id}/${tab}`
}

export const isFeatureEnabled = (link: TenantFeature): boolean => {
  return links[link].enabled.includes(checkWindowLocation())
}

export const isEnabledOnEnvs = (envs: appENV[]): boolean => {
  return envs.includes(checkWindowLocation())
}
